import { render, staticRenderFns } from "./ServiceContent.vue?vue&type=template&id=27254f4a&scoped=true"
import script from "./ServiceContent.vue?vue&type=script&lang=js"
export * from "./ServiceContent.vue?vue&type=script&lang=js"
import style0 from "./ServiceContent.vue?vue&type=style&index=0&id=27254f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27254f4a",
  null
  
)

export default component.exports